export default "__VITE_ASSET__CvIrtutW__"